import {createStore, applyMiddleware} from "redux";
import {persistStore, persistReducer} from "redux-persist";
import createOidcMiddleware from 'redux-oidc';
import storage from "redux-persist/lib/storage";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import {createLogger} from "redux-logger";
import promiseMiddleware from 'redux-promise-middleware';
import rootReducer from './redux/reducers';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import userManager from './userManager';
import {createBrowserHistory} from 'history';

const persistConfig = {
  key: "state",
  storage,
  whitelist: ['ppg', 'application', 'oidc', 'captcha', 'pdfLink', 'address', 'referenceDataDetail', 'qualificationDetail', 'locationDetail', 'focusOfWorkDetail','associateDetail',
    'projectDetail','organisationDetail','personalDetails','documentDetail', 'identityProof', 'intlIdentityProof',
    'history', 'mentalCapacity', 'competitionDetails', 'paymentSuccess', 'form', 'applicantDetails', 'facilityDetails', 'individualRoles',
    'importExportDetails','interStateDetails','speciesDetails', 'speciesSearchDetails', 'licenceApplicationDetails', 'declarationDetails', 'floraFaunaDeclarationDetails',
    'licenceDetails', 'organisationApplicationDetails', 'attachmentDetails', "fees", "twoFA"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewares = [thunk, promiseMiddleware, reduxImmutableStateInvariant()];
const oidcMiddleware = createOidcMiddleware(userManager);
if (process.env.NODE_ENV !== "production") {
  middlewares.push(createLogger());
}
middlewares.push(oidcMiddleware);

const configureStore = preloadedState => {
  const store = createStore(
    persistedReducer,
    preloadedState,
    composeWithDevTools(
      applyMiddleware(...middlewares)
    )
  );
  const persistor = persistStore(store);
  return {store, persistor};
};

export const history = createBrowserHistory();

export default configureStore;
